export default "__VITE_ASSET__Cycj706D__"